module.exports = __webpack_public_path__ + "static/media/icn-metamask.e8109252.svg";